(() => {
  if (document.documentElement.dataset.contactEventsReady === 'true') return;

  document.documentElement.dataset.contactEventsReady = 'true';

  const whatsappHosts = new Set(['wa.me', 'api.whatsapp.com']);
  const whatsappNumber = '525548780435';
  const directionsHost = 'maps.app.goo.gl';
  const directionsPath = '/rGe9FQHpb1KZdhtS9';
  const phoneNumber = '525555261701';
  const formSuccessKey = 'dmContactFormSuccessTracked';

  const normaliseNumber = (value) => value.replace(/\D/g, '');

  const getContactLocation = (link) => {
    if (link.closest('header')) return 'header';
    if (link.closest('footer')) return 'footer';

    const { pathname } = window.location;

    if (pathname === '/pages/contact') return 'contact';
    if (pathname === '/pages/muebleria-la-lagunilla') return 'local_page';
    if (pathname === '/pages/muebles-a-medida-cdmx') return 'custom_order';
    if (pathname.indexOf('/products/') === 0) return 'product';
    if (pathname.indexOf('/collections/') === 0) return 'collection';

    return 'page';
  };

  const sendEvent = (eventName, parameters) => {
    if (typeof window.gtag !== 'function') return false;

    window.gtag('event', eventName, {
      page_location: window.location.origin + window.location.pathname,
      page_path: window.location.pathname,
      ...parameters,
    });

    return true;
  };

  const trackContactLink = (event) => {
    const link = event.target.closest('a[href]');
    if (!link) return;

    let destination;

    try {
      destination = new URL(link.href, window.location.origin);
    } catch {
      return;
    }

    const contactLocation = getContactLocation(link);
    if (
      whatsappHosts.has(destination.hostname)
      && normaliseNumber(destination.pathname + destination.search).includes(whatsappNumber)
    ) {
      sendEvent('contact_whatsapp', {
        contact_location: contactLocation,
        link_url: `${destination.origin}${destination.pathname}`,
      });
      return;
    }

    if (destination.hostname === directionsHost && destination.pathname === directionsPath) {
      sendEvent('contact_directions', {
        contact_location: contactLocation,
        link_url: `${destination.origin}${destination.pathname}`,
      });
    }
  };

  const trackPhoneLink = (event) => {
    const link = event.target.closest('a[href]');
    if (!link) return;

    let destination;

    try {
      destination = new URL(link.href, window.location.origin);
    } catch {
      return;
    }

    if (destination.protocol !== 'tel:' || !normaliseNumber(destination.pathname).endsWith(phoneNumber)) return;

    sendEvent('contact_phone', {
      contact_location: getContactLocation(link),
    });
  };

  const trackContactFormSuccess = () => {
    if (!document.querySelector('[data-contact-form-success]')) return;

    try {
      if (window.sessionStorage.getItem(formSuccessKey) === '1') return;
    } catch {}

    if (sendEvent('contact_form_submit', {
      contact_location: 'contact',
      form_destination: window.location.origin + window.location.pathname,
      form_id: 'ContactForm',
      form_name: 'contact',
    })) {
      try {
        window.sessionStorage.setItem(formSuccessKey, '1');
      } catch {}
    }
  };

  const initialiseTracking = () => {
    document.addEventListener('click', trackContactLink, { capture: true });
    document.addEventListener('pointerdown', trackPhoneLink, { capture: true });
    document.addEventListener('click', (event) => {
      if (event.detail === 0) trackPhoneLink(event);
    }, { capture: true });
    document.addEventListener('submit', (event) => {
      if (event.target.id === 'ContactForm') {
        try {
          window.sessionStorage.removeItem(formSuccessKey);
        } catch {}
      }
    }, { capture: true });

    trackContactFormSuccess();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiseTracking, { once: true });
  } else {
    initialiseTracking();
  }
})();
